import { z } from 'zod';

import { cameraSelectionSchema } from './camera-mapping';
import { videoIntegrationMetadataPayloadSchema } from './video-integration-metadata-payload';

export type UpdateVideoIntegrationPayload = z.infer<typeof updateVideoIntegrationPayloadSchema>;

export const updateVideoIntegrationPayloadSchema = z.object({
  active: z.boolean().optional(),
  cameras: z.array(cameraSelectionSchema).optional(),
  meta: videoIntegrationMetadataPayloadSchema.optional(),
  name: z.string().trim().min(1).optional(),
});
